/**
 * How a category value reads in the printed category summary (it was the old
 * on-screen category cards' `describe`; the tab's coverage table now words its
 * own cells).
 *
 * "-" used to mean three unrelated things at once: nothing was quoted, the
 * benefit is unlimited so "remaining" is meaningless, and the carrier stated a
 * percentage but no dollar cap. They rendered identically, so the office could
 * not tell "we don't know" from "there is no limit". Each now says what it means.
 *
 * `label` is one of "Overall Max" | "Coverage Percentage" | "Remaining Benefits".
 * Returns { text, hint }.
 */
export const UNLIMITED_SENTINEL = "9999999.99";

export function describeCategoryValue(label, field, isUnlimited, hasPercentage) {
  const empty = field === null || field === undefined || field === "";

  if (empty) {
    if (label === "Coverage Percentage") {
      return { text: "Not quoted", hint: "The carrier did not quote a percentage for this category." };
    }
    // A percentage came back but no dollar figure: the carrier answered and
    // explicitly stated no maximum (SunLife prints "Overall maximum: None").
    if (hasPercentage) {
      return label === "Overall Max"
        ? { text: "No max stated",
            hint: "The carrier quoted a percentage but no dollar maximum for this category. Submit a predetermination to confirm the actual figure." }
        : { text: "Unknown",
            hint: "Remaining benefit can't be calculated without a stated maximum. Submit a predetermination for the actual figure." };
    }
    return { text: "Not quoted", hint: "The carrier returned no information for this category." };
  }

  const big = field === UNLIMITED_SENTINEL || Number(field) >= 9000000;

  if (label === "Remaining Benefits" && (isUnlimited || big)) {
    return { text: "No limit", hint: "This category has no dollar maximum, so there is no remaining balance to track." };
  }
  if (big) {
    return label === "Overall Max"
      ? { text: "Unlimited", hint: "No dollar maximum applies to this category." }
      : { text: String(field), hint: "" };
  }
  if (label === "Coverage Percentage") {
    return { text: `${field}%`, hint: "" };
  }
  return { text: `$${field}`, hint: "" };
}
